export default "__VITE_ASSET__PLSIlg63__"